export default __webpack_public_path__ + "static/media/hop3.70515141.jpg";